"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PIVOT_GRAND_TOTALS = exports.isPivotMeasure = exports.isPivotAttribute = void 0;
/**
 * Runs type guard check for PivotAttribute.
 *
 * @param arg - object to check
 * @internal
 */
function isPivotAttribute(arg) {
    return 'attribute' in arg;
}
exports.isPivotAttribute = isPivotAttribute;
/**
 * Runs type guard check for PivotMeasure.
 *
 * @param arg - object to check
 * @internal
 */
function isPivotMeasure(arg) {
    return 'measure' in arg;
}
exports.isPivotMeasure = isPivotMeasure;
/**
 * @internal
 */
exports.DEFAULT_PIVOT_GRAND_TOTALS = {
    rows: false,
    columns: false,
};
